export default __webpack_public_path__ + "static/media/edit_filtered_result.4ff9ce5a.svg";